module.exports = __webpack_public_path__ + "static/beats-ad-ac7267e151df782760f87303ac23f749.jpg";